<template>

<div class="info" v-on:click="onClick" v-click-outside="onOutsideClick" :class="{'is-auto': auto, 'is-light': light, 'is-modal': modal}">

	<portal to="info">

		<div class="info-wrapper" v-if="is.active">

			<button class="info-x" v-if="!window.is.desktop || modal" v-on:click="onCloseClick($event)"><span>X</span></button>

			<div class="info-text" ref="text" v-html="text"></div>

			<button class="info-close" v-if="window.is.desktop && !modal" v-on:click="onCloseClick($event)"><span>Close</span></button>

		</div>

	</portal>

</div>

</template>

<script>

import vClickOutside from 'v-click-outside'

export default {

	props: ['info', 'auto', 'light', 'modal', 'block'],

    directives: {
		clickOutside: vClickOutside.directive
    },

	data: function() {

		return {
			id: 0,
			is: {
				block: false,
				active: false
			},
			links: []
		}

	},

	computed: {

		text: function() {

			return (this.id) ? this.$store.getters[(this.is.block) ? 'data/decision/blocks' : 'data/reference/info'][this.id].text : false

		}

	},

	watch: {

		text: function() {

			this.$_.each(this.links, function(link) {

				link.removeEventListener('click', this.onLinkClick.bind(this))

			}.bind(this))	

			this.$nextTick(function() {

				if(this.$refs.text) {

					this.$_.each(this.$refs.text.getElementsByTagName('a'), function(link) {

						if (link.getAttribute('data-link-type') === '1' || link.getAttribute('data-link-type') === '5') {

							this.links.push(link)

						} 

						link.addEventListener('click', this.onLinkClick.bind(this))

					}.bind(this))

				}

			}.bind(this))

		}

	},

	created: function() {

		if (this.auto) {

			this.is.active = true
			this.id = this.info
			this.is.block = this.block
			this.$pubsub.$emit('overlay')

		}

	},

	beforeDestroy: function() {

		this.$_.each(this.links, function(link) {

			link.removeEventListener('click', this.onLinkClick.bind(this))

		}.bind(this))	

	},

	methods: {

		onLinkClick: function(e) {

			e.stopPropagation()
			
			if (e.srcElement.getAttribute('data-link-type').toString() === '1') {

				e.preventDefault()
				this.is.block = false
				this.id = parseInt(e.srcElement.getAttribute('data-link-page'))

			} else if (e.srcElement.getAttribute('data-link-type').toString() === '5') {

				e.preventDefault()
				this.is.block = true
				this.id = parseInt(e.srcElement.getAttribute('data-link-page'))

			}

		},

		onCloseClick: function(e) {

			e.preventDefault()
			e.stopPropagation()

			if (this.is.active) this.$pubsub.$emit('overlay')

			this.is.active = false
			this.$emit('close')

		},

		onClick: function(e) {

			e.preventDefault()
			e.stopPropagation()

			if (!this.is.active) this.id = this.info

			this.is.active = !this.is.active

			if (!this.is.active) this.$emit('close')

			this.$pubsub.$emit('overlay')
		},

		onOutsideClick: function() {

			if (this.modal) return false

			if (this.is.active) this.$pubsub.$emit('overlay')
			this.is.active = false
			this.$emit('close')

		}

	}

}

</script>

<style scoped>

.info {
	height: 24px;
	width: 24px;
	background-image: url(~@/assets/info.svg);
	background-size: 24px 24px;
	flex-shrink: 0;
	position: absolute;
	right: -48px;
	top: 12px;
	user-select: none;
	cursor: pointer;
}

.info.is-auto {
	width: 0px;
	height: 0px;
}

.is-mobile .info {
	right: 0px;
	top: 2px;
	height: 20px;
	width: 20px;
	background-size: 20px 20px;
}

.info-wrapper {
	/*position: absolute;
	right: -64px;
	top: 64px;
	width: 910px;
	background-color: #343434;
	color: #fff;
	padding: 32px;
	border-radius: 32px;
	z-index: 100;
	margin-bottom: 32px;*/
	position: fixed;
	left: 0px;
	top: 0px;
	bottom: 0px;
	right: 0px;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: #fff;
	color: #343434;
	z-index: 10000;
	padding: 0px calc((100vw - 1000px) / 2);
	font-size: 24px;
	line-height: 28px;
	flex-direction: column;
	overflow: auto;
}

.is-desktop .info.is-modal .info-wrapper {
	top: 48px;
	max-height: calc(100vh - 96px);
	position: fixed;
	left: calc(50% - 300px);
	z-index: 1000;
	overflow-y: auto;
}

.is-desktop .info.is-light .info-wrapper {
	background-color: #fff;
	color: #343434;
}

.is-tablet .info-wrapper,
.is-mobile .info-wrapper {
	position: fixed;
	left: 0px;
	top: 0px;
	right: 0px;
	width: 100%;
	overflow-y: scroll;
	overflow-x: hidden;
	bottom: 0px;
	z-index: 1000;
	border-radius: 0px;
	padding: 15px;
	padding-bottom: 64px;
	margin-bottom: 0px;
}

.info-wrapper:before {
	content: ' ';
	width: 38px;
	height: 38px;
	background-color: #343434;
	position: absolute;
	top: -38px;
	right: 74px;
	clip-path: polygon(100% 0, 0% 100%, 100% 100%);
}

.is-desktop .info.is-modal .info-wrapper:before {
	display: none;
}

.info-text >>> strong,
.info-text >>> b {
	font-weight: 700;
}

.info-text >>> p {
	font-size: 24px;
	line-height: 28px;
	letter-spacing: 1px;
	font-weight: 300;
	margin-bottom: 16px;
	color: #333;
}

.is-mobile .info-text >>> p {
	font-size: 16px;
	line-height: 20px;
}

.info-text >>> ul {
	list-style: disc;
	list-style-position: outside;
	margin-bottom: 16px;
}

.info-text >>> ul ul {
	margin-left: 32px;
	list-style: revert;
	margin-bottom: 0px;
}

.info-text >>> li {
	font-size: 24px;
	line-height: 28px;
	letter-spacing: 1px;
	font-weight: 300;
	margin-left: 16px;
}

.is-mobile .info-text >>> li {
	font-size: 16px;
	line-height: 20px;
}

.info-text >>> img {
	max-width: 100%;
	width: auto!important;
	height: auto!important;
}

.info-text >>> a {
	border-bottom: 1px dashed rgba(255, 255, 255, 0.5);
}

.info-text >>> a:hover {
	border-bottom: 1px dashed rgba(255, 255, 255, 1);
}

.info-text >>> *:last-child {
	margin-bottom: 0px;
}

.info-text >>> *:last-child {
	margin-bottom: 0px;
}

.info-close {
	min-width: 150px;
	padding: 0px 20px;
	height: 48px;
	border-radius: 24px;
	border: 2px solid #fff;
	font-size: 18px;
	font-weight: 700;
	color: #fff;
	background-color: #343434;
	margin-top: 20px;
	transition: all 300ms ease-in-out;
}

.is-tablet .info-close {
	margin-top: 16px;
}

.is-mobile .info-close {
	width: 100%;
	margin: 0px 0px 10px 0px;
	min-height: 32px;
	line-height: 18px;
	font-size: 14px;
	padding: 0px 10px;
	border-radius: 16px;
	margin-top: 16px;
}

.info-x {
	position: fixed;
	right: 0px;
	top: 0px;
	width: 40px;
	height: 40px;
	line-height: 40px;
	background-color: #343434;
	z-index: 1001;
	color: #fff;
	text-align: center;
	font-size: 32px;
}

.is-mobile .info-x {
	right: calc(50% - 20px);
	bottom: 10px;
	top: auto;
	border-radius: 50%;
	font-size: 24px;
}

.is-desktop .info.is-modal .info-x {
	right: 10px;
	top: 10px;
	position: absolute;
	border-radius: 0px 24px 0px 0px;
}

.is-desktop .info.is-light .info-x {
	color: #343434;
	background-color: #fff;
}

</style>